export default {"src":"/_next/static/media/error500.66da7cad.svg","height":173,"width":113};